export const BASE_URL = process.env.REACT_APP_API_URL;
export const BASE_WS_URL = process.env.REACT_APP_WS_URL;

export const getWSUrl = () => {
    let WS_URL = BASE_WS_URL;

    if (typeof BASE_WS_URL === 'undefined') {
        WS_URL = `wss://${window.location.hostname}:${window.location.port}/api/ws/`;
    }

    return WS_URL;
};

export const DOCS_LINK = '/static/media/doc.pdf';
export const VIDEO_TUTORIAL_LINK = '/static/media/video.mp4';
export const JIRA_PROJECT_LINK = 'https://jira.esafeline.com/projects/UTMS/summary';
